import React from 'react';
export function TargetAudience() {
  return <section className="py-20 bg-zinc-950" data-id="element-245">
      <div className="container mx-auto px-4" data-id="element-246">
        <div className="max-w-5xl mx-auto" data-id="element-247">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center mb-16 text-white uppercase tracking-wide" data-id="element-248">
            ESTO ES PARA VOS SI…
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-249">
            {/* Principiantes */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8" data-id="element-250">
              <h3 className="text-2xl font-bold text-amber-500 mb-8 border-b border-zinc-800 pb-4" data-id="element-251">
                Todavía no aprendiste a hacer asado:
              </h3>
              <ul className="space-y-6" data-id="element-252">
                {['Nunca lo hiciste solo y siempre esperás que se haga cargo otro', 'Le tenés miedo al fuego y a quedar como un boludo la primera vez', 'Querés aprender de una vez por todas con un sistema de verdad y no con consejos contradictorios'].map((text, i) => <li key={i} className="flex items-start" data-id="element-253">
                    <span className="text-amber-500 mr-4 text-xl" data-id="element-254">→</span>
                    <p className="text-zinc-300 leading-relaxed" data-id="element-255">{text}</p>
                  </li>)}
              </ul>
            </div>

            {/* Experimentados */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8" data-id="element-256">
              <h3 className="text-2xl font-bold text-amber-500 mb-8 border-b border-zinc-800 pb-4" data-id="element-257">
                Ya hacés asados pero querés más:
              </h3>
              <ul className="space-y-6" data-id="element-258">
                {['A veces sale bien, a veces no, y no sabés exactamente por qué', 'Querés que el vacío, la entraña y el costillar salgan en punto cada vez sin depender de la suerte', 'Querés dominar las técnicas del campo que casi nadie en el barrio conoce'].map((text, i) => <li key={i} className="flex items-start" data-id="element-259">
                    <span className="text-amber-500 mr-4 text-xl" data-id="element-260">→</span>
                    <p className="text-zinc-300 leading-relaxed" data-id="element-261">{text}</p>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}